import { useState, useEffect } from 'react';
import { Tabs, Row, Col, Card, Button, Skeleton, Spin, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import numeral from 'numeral';
import { isMobileOnly } from 'react-device-detect';
import editIcon from '../../../../assets/onboarding/editIcon.svg';
import EditData from './EditData';
import { titlePageMobile } from '../../../HerramientasVenta/reusableItems';
import TotalDifference from '../Modals/TotalDifference';
import DifferenceInQuota from '../Modals/DifferenceInQuota';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setDataViabilityForSubrogationOnboarding } from '../../../../store/viability/actions';
import { VIABILITYDATASUBROGATION } from '../../../../store/viability/constants';
import ComplicatedViability from '../../Components/ComplicatedViability';
import env from '../../../../environment';
import axios from 'axios';
import { LoadingOutlined } from '@ant-design/icons';
import { stages } from '../../../../store/auth/actions';
import { useNavigate } from 'react-router-dom';
import logoMortgage from '../../../../assets/onboarding/logoMortgage.svg';
import logoMortgageMobile from '../../../../assets/onboarding/logoMortgageMobile.svg';
import CondictionsLegal from './CondictionsLegal';
import viabilityIcon1 from '../../../../assets/onboarding/viabilityIcon1.png';
import viabilityIcon2 from '../../../../assets/onboarding/viabilityIcon2.png';
import viabilityIcon3 from '../../../../assets/onboarding/viabilityIcon3.png';
import { trace } from '../../../../components/tagmanager';

const ResultSubrogation = ({ dataOperation, refreshData }) => {
	const { t } = useTranslation();
	const { operationId } = useParams();
	const [visibleModalCalculationAmount, setVisibleModalCalculationAmount] = useState(false);
	const [visibleModalSavings, setVisibleModalSavings] = useState(false);
	const [recalculateViability, setRecalculateViability] = useState(false);
	const userToken = useSelector((state) => state.auth.token);
	const viabilityDataSubrogation = useSelector((state) => state.viability.viabilitySubrogation);
	const [changePages, setChangesPages] = useState(1);
	const antIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />;
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	const dispatch = useDispatch();
	useEffect(() => {
		dispatch({
			type: VIABILITYDATASUBROGATION,
			payload: undefined
		});
		if (dataOperation !== undefined) {
			dispatch(
				setDataViabilityForSubrogationOnboarding(
					dataOperation && dataOperation.subrogation.amount,
					dataOperation && dataOperation.subrogation.dateEndMortgage,
					dataOperation &&
						dataOperation.subrogation.interest &&
						dataOperation.subrogation.interest === 'fixed'
						? dataOperation.subrogation.haveATin
						: undefined,
					dataOperation &&
						dataOperation.subrogation.interest &&
						dataOperation.subrogation.interest === 'variable'
						? dataOperation.subrogation.haveATin
						: undefined,
					operationId,
					userToken
				)
			);
		}
		changesStage('process', 'basicCompleted', true);
	}, []);

	useEffect(() => {
		if (recalculateViability) {
			dispatch({
				type: VIABILITYDATASUBROGATION,
				payload: undefined
			});
			dispatch(
				setDataViabilityForSubrogationOnboarding(
					dataOperation && dataOperation.subrogation.amount,
					dataOperation && dataOperation.subrogation.dateEndMortgage,
					dataOperation &&
						dataOperation.subrogation.interest &&
						dataOperation.subrogation.interest === 'fixed'
						? dataOperation.subrogation.haveATin
						: undefined,
					dataOperation &&
						dataOperation.subrogation.interest &&
						dataOperation.subrogation.interest === 'variable'
						? dataOperation.subrogation.haveATin
						: undefined,
					operationId,
					userToken
				)
			);
			setRecalculateViability(false);
		}
	}, [dataOperation]);

	useEffect(() => {
		if (viabilityDataSubrogation && dataOperation) {
			trace({
				location,
				userToken,
				stage: 'basic_02_OK',
				operationName: operationId,
				viability: 5,
				operationType: 'subrogation'
			});
		}
	}, [viabilityDataSubrogation, dataOperation]);

	const changesStage = (owner, key, value) => {
		setLoading(true);
		axios
			.post(
				`${env.api.url}/v1/mortgages/data/update/${operationId}`,
				{ key, participant: owner, value },
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				if (response.data.success) {
					axios
						.post(
							`${env.api.url}/v1/mortgages/check-full-declaratives`,
							{ operationId: operationId },
							{
								headers: { Authorization: `Bearer ${userToken}` }
							}
						)
						.then((response) => {
							if (response.data.success) {
								axios
									.get(`${env.api.url}/v1/auto-things/AutoStagesGenerator/${operationId}`, {
										headers: {
											Authorization: `Bearer ${userToken}`
										}
									})
									.then((response) => {
										if (response.data.success) {
											dispatch(stages(response.data.data.currentStage));
											navigate(`/operations/${operationId}/${response.data.data.currentStage}`);
											setLoading(false);
										}
									});
							}
						});
				}
			});
	};


	const typeOfQuote = (
		title,
		index,
		quote,
		savings,
		fixed,
		titleVariable,
		fixedTin,
		quote1,
		variable,
		type,
		years
	) => {
		if (savings < 0) {
			return (
				<Col span={!isMobileOnly ? 12 : 24} style={{ marginTop: 25 }}>
					<div
						className="viability-quote"
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-around'
						}}>
						<div className="title" style={{ marginBottom: !isMobileOnly && 4 }}>
							{t(title)} <sup>{index}</sup>
						</div>
					</div>
					<div className="viability-quote savings-subrogation">
						<div className="title">{t('onboarding.subrogationPayRed')}</div>
						<div
							className="sub-title-subrogation"
							dangerouslySetInnerHTML={{
								__html: t('onboarding.subrogationPayRed2', {
									rateType: t('form.variable')
								})
							}}
						/>
					</div>
				</Col>
			);
		} else {
			return (
				<>
					{viabilityDataSubrogation !== undefined ? (
						<Col span={!isMobileOnly ? 12 : 24} style={{ marginTop: 24 }}>
							<div
								className={'viability-quote'}
								style={{
									height: '100%',
									padding: isMobileOnly && 16,
									border: isMobileOnly && '1px solid #C0DAEE'
								}}>
								<div className="title" style={{ marginBottom: 16 }}>
									{t(title)} <sup>{index}</sup>
								</div>
								<div style={{ display: 'flex', justifyContent: 'center' }}>
									<div className="quote" style={{ color: '#757575' }}>
										{title === 'typeFixed.bonificate' || title === 'typeVar.bonificate' || title === 'typeMixed.bonificate'
											? t('__sabadell-es__onboarding.relatedProducts') + ':'
											: t('onboarding.noRelatedProducts')}
									</div>
									{(title === 'typeFixed.bonificate' || title === 'typeVar.bonificate' || title === 'typeMixed.bonificate') && (
										<div style={{ display: 'flex', marginTop: -4 }}>
											<Tooltip title={t('icon.viability1')}>
												<img
													src={viabilityIcon1}
													alt="house"
													style={{ width: 28, height: 28 }}></img>
											</Tooltip>
											<Tooltip title={t('icon.viability2')}>
												<img
													src={viabilityIcon2}
													alt="lock"
													style={{ width: 28, height: 28 }}></img>
											</Tooltip>
											<Tooltip title={t('icon.viability3')}>
												<img
													src={viabilityIcon3}
													alt="heart"
													style={{ width: 28, height: 28 }}></img>
											</Tooltip>
										</div>
									)}
								</div>

								<div
									className="percentage"
									style={{ marginBottom: 16, fontWeight: 700, marginTop: 16 }}>
									{(title === "typeFixed.bonificate" || title === "typeFixed.nobonificate") ? t('appraisal.nameTableTae') : t('appraisal.nameTableTae') + " Variable"}: {numeral(fixed).format('0,0.00') + '%'}
								</div>
								<div
									className="wrapper-quote"
									style={{
										marginBottom: 0,
										justifyContent: 'space-between'
									}}>
									<div>
										{
											<div
												className="quote"
												style={{
													color: '#757575',
													textAlign: 'left',
													marginBottom: 4
												}}>
												{title === 'typeVar.bonificate' || title === 'typeVar.nobonificate'
													? t('viability.new') + ' ' + t('onboarding.quoteFirstYear').toLowerCase()
													: title === 'typeMixed.bonificate' || title === 'typeMixed.nobonificate'
														? t('viability.new') + ' ' + t('onboarding.quoteMoreYears', { years: years }).toLowerCase()
														: t('viability.new') + ' ' + t('viability.monthlyPayments')}
											</div>
										}
										<div className="price" style={{ textAlign: 'left' }}>
											{quote < 0 ? numeral(0).format('0,0 $') : numeral(quote).format('0,0 $')}/
											{t('viability.monthsEstimated')}
										</div>
									</div>
									<div style={{ alignSelf: 'end' }}>
										{!isMobileOnly && (
											<div className="quote" style={{ color: '#757575', height: 24 }}></div>
										)}
										<div className="price-variable">
											{t('appraisal.nameTableTin')}: {numeral(fixedTin).format('0,0.00') + '%'}{' '}
										</div>
									</div>
								</div>
								{titleVariable !== 'onboarding.fixedSpread' && (
									<div
										className="wrapper-quote"
										style={{
											marginBottom: 0,
											marginBottom: 0,
											justifyContent: 'space-between',
											marginTop: 16
										}}>
										<div>
											{
												<div className="quote" style={{ color: '#757575', textAlign: 'left' }}>
													{t('viability.new') + " " + t('onboarding.quoteRestYear').toLowerCase()}
												</div>
											}
											<div className="price" style={{ textAlign: 'left' }}>
												{quote1 < 0 ? numeral(0).format('0,0 $') : numeral(quote1).format('0,0 $')}/
												{t('viability.monthsEstimated')}
											</div>
										</div>
										<div style={{ alignSelf: 'end' }}>
											{!isMobileOnly && (
												<div className="quote" style={{ color: '#757575', height: 24 }}></div>
											)}
											<div className="price-variable">
												{t('appraisal.nameTableTin')}:{' EUR + '}
												{numeral(variable).format('0,0.00')}
												{'%'}
											</div>
										</div>
									</div>
								)}
								<div
									style={{ height: 1, width: '100%', background: '#239D45', marginTop: 16 }}></div>
								<div
									style={{
										display: 'flex',
										marginBottom: 4,
										justifyContent: 'space-between',
										marginTop: 6,
										flexDirection: isMobileOnly && 'column',
										rowGap: isMobileOnly && 6
									}}>
									<div
										className="quote"
										style={{
											color: '#239D45',
											textAlign: !isMobileOnly && 'left'
										}}>
										{savings > 0 ? <div>{t('onboarding.youWillSave')}<sup>{8}</sup></div> : t('onboarding.youWillPay')}{' '}


									</div>
									<div
										className="price"
										style={{
											color: '#239D45',
											textAlign: !isMobileOnly && 'left',
											fontSize: 18,
											marginTop: 4
										}}>
										{numeral(Math.abs(savings)).format('0,0 $')} {savings < 0 && 'más'}
										{/* // no borrar porque luego hay que habilitar el modals
										<InfoCircleOutlined
											style={{ color: '#006DFF', fontSize: 20, marginLeft: 4 }}
											onClick={() =>
												setVisibleModalSavings({
													title: titleVariable,
													quote,
													savings,
													fixed,
													currentQuote,
													pendingTerm,
													fixedTin,
													quote1,
													variable,
													annualCostLinkages,
													costOtherProducts,
													dateEndMortgage,
													monthlySavings
												})
											}
										/>*/}
									</div>
								</div>
								<div
									className="quote"
									style={{
										color: '#757575',
										fontSize: 12,
										marginTop: 6,
										textAlign: !isMobileOnly && 'left'
									}}>
									{dataOperation?.subrogation?.interest === type
										? t('onboarding.subrogationWithoutChangeMod')
										: t('onboarding.fixedChange', {
											type:
												titleVariable === 'onboarding.fixedSpread'
													? t('viability.fixedSpread').toLowerCase()
													: titleVariable === 'viability.mixedSpread'
														? t('viability.mixedSpread').toLowerCase()
														: t('viability.variableSpread').toLowerCase()
										})}
								</div>
							</div>
						</Col>
					) : (
						<>
							<Col span={!isMobileOnly ? 12 : 24} className="viability-quote">
								<Skeleton active />
							</Col>
						</>
					)}
				</>
			);
		}
	};

	const continueOperation = (
		<div
			style={{
				border: '1px solid #006DFF',
				borderRadius: 4,
				padding: 24,
				margin: '0px auto 32px',
				textAlign: 'center',
				background: '#FFFFFF',
				display: 'flex',
				textAlign: 'left',
				columnGap: !isMobileOnly && 24,
				flexDirection: isMobileOnly && 'column',
				rowGap: isMobileOnly && 16
			}}>
			<img
				src={isMobileOnly ? logoMortgageMobile : logoMortgage}
				alt="logoMortgage"
				style={{ height: 100 }}
			/>
			<div>
				<div
					className="title-less-pay"
					style={{
						marginBottom: 16
					}}>
					{t('onboarding.wantPayLess')}
				</div>
				<div className="sub-title-less-pay">{t('onboarding.goAheadToAnalyzeSubrogation')}</div>
			</div>
		</div>
	);

	const renderDisabled = (dataOperation, viabilityDataSubrogation) => {
		if (dataOperation?.subrogation?.amount < 50000) {
			return true
		} else if (dataOperation?.subrogation?.whenSignedMortgage === 'lessThanOneYear') {
			return true
		} else if (viabilityDataSubrogation?.excepcionalViability !== undefined) {
			return true
		} else {
			return false
		}
	}

	return(<></>);
	// return (
	// 	<>
	// 		{changePages === 2 && (
	// 			<EditData
	// 				changePage={titlePageMobile((e) => setChangesPages(e), 1, t('loan.editData'))}
	// 				type="subrogation"
	// 				dataOperation={dataOperation}
	// 				refreshData={() => refreshData()}
	// 				setPages={(e) => setChangesPages(e)}
	// 				setRecalculateViability={(e) => setRecalculateViability(e)}
	// 			/>
	// 		)}
	// 		{changePages === 1 &&
	// 			(!loading ? (
	// 				<div
	// 					style={{
	// 						padding: isMobileOnly ? 16 : 40,
	// 						marginBottom: 150,
	// 						marginTop: -32
	// 					}}>
	// 					<div
	// 						style={{
	// 							display: 'flex',
	// 							justifyContent: 'space-between',
	// 							alignItems: 'center',
	// 							marginBottom:
	// 								!viabilityDataSubrogation?.excepcionalViability && !isMobileOnly ? -42 : 26
	// 						}}>
	// 						<img src={''} alt="" height={50} />
	// 						{/* COLOCAR LA CONDICION CON LA VIABILIDAD COMPLICADA */}
	// 						{!viabilityDataSubrogation?.excepcionalViability && (
	// 							<div
	// 								style={{
	// 									display: 'flex',
	// 									justifyContent: 'space-between',
	// 									alignItems: 'center'
	// 								}}>
	// 								<img src={editIcon} alt="Gibobs" height={16} />
	// 								<div
	// 									style={{
	// 										color: '#006DFF',
	// 										fontSize: 14,
	// 										fontWeight: 500,
	// 										lineHeight: '20px',
	// 										marginLeft: 4,
	// 										cursor: 'pointer'
	// 									}}
	// 									onClick={() => setChangesPages(2)}>
	// 									{t('loan.editData')}
	// 								</div>
	// 							</div>
	// 						)}
	// 					</div>
	// 					{dataOperation &&
	// 						dataOperation.subrogation &&
	// 						dataOperation.subrogation.whenSignedMortgage === 'lessThanOneYear' &&
	// 						!viabilityDataSubrogation?.excepcionalViability && (
	// 							<ComplicatedViability
	// 								title={'onboarding.lessThanOneYearTitle'}
	// 								description={'onboarding.lessThanOneYearDescription'}
	// 								setPages={(e) => setChangesPages(e)}
	// 							/>
	// 						)}

	// 					{viabilityDataSubrogation &&
	// 						viabilityDataSubrogation.excepcionalViability === 'LOW_SUBROGATION' && (
	// 							<ComplicatedViability
	// 								title={'onboarding.lowSubrogationTitle'}
	// 								description={'onboarding.outstandingCapitalDescription'}
	// 								capital={numeral(dataOperation?.subrogation?.amount).format('0,0')}
	// 								setPages={(e) => setChangesPages(e)}
	// 							/>
	// 						)}
	// 					{viabilityDataSubrogation &&
	// 						viabilityDataSubrogation.excepcionalViability === 'NOT_IMPROVE_SUBROGATION' && (
	// 							<ComplicatedViability
	// 								title={'onboarding.lowSubrogationTitle'}
	// 								description={'onboarding.notImproveSubrogationDesc2'}
	// 								setPages={(e) => setChangesPages(e)}
	// 							/>
	// 						)}{' '}
	// 					<div
	// 						style={{
	// 							marginBottom: 200,
	// 							width: !isMobileOnly && '100%',
	// 							margin: 'auto'
	// 						}}>
	// 						<div style={{ display: 'flex', justifyContent: 'center', marginBottom: 26 }}>
	// 							<div style={{ fontSize: 24, color: '#000000', fontWeight: 700 }}>
	// 								{t('viability.resultTitle')}
	// 							</div>
	// 						</div>
	// 						<div className="sub-title-subrogation" >{t('onboarding.yourResultDescription')}</div>
	// 					</div>
	// 					<Tabs
	// 						className={
	// 							isMobileOnly ? 'tabs-onboarding-mortgage-mobile' : 'tabs-onboarding-mortgage'
	// 						}
	// 						defaultActiveKey="1"
	// 						centered
	// 						style={{
	// 							marginBottom: 200,
	// 							width: !isMobileOnly && 900,
	// 							margin: '24px auto 0px'
	// 						}}>
	// 						<Tabs.TabPane tab={isMobileOnly ? t('mortgage.fixedtabmob').toUpperCase() : t('mortgage.fixedtab').toUpperCase()} key="1">
	// 							<Row gutter={24} style={{ margin: '-10px -8px 20px' }}>
	// 								{viabilityDataSubrogation?.monthlyFixedSavings < 0 ? (
	// 									<>
	// 										<Col span={24} style={{ marginTop: 8 }}>
	// 											<div
	// 												className="card-subrogation-need-information"
	// 												style={{
	// 													columnGap: !isMobileOnly && 24,
	// 													flexDirection: isMobileOnly && 'column',
	// 													rowGap: isMobileOnly && 16
	// 												}}>
	// 												<img
	// 													src={isMobileOnly ? logoMortgageMobile : logoMortgage}
	// 													alt="logoMortgage"
	// 													height={'100%'}
	// 												/>
	// 												<div>
	// 													<div className="title-suborgation-information">
	// 														{t('onboarding.subrogationPayRed')}
	// 													</div>
	// 													<div
	// 														className="sub-title-suborgation-information"
	// 														dangerouslySetInnerHTML={{
	// 															__html: t('onboarding.subrogationPayRed2', {
	// 																rateType: t('onboarding.fixedMortgage')
	// 															})
	// 														}}
	// 													/>
	// 												</div>
	// 											</div>
	// 										</Col>
	// 									</>
	// 								) : (
	// 									<>
	// 										{/* TIPO FIJO BONIFICADO*/}
	// 										{typeOfQuote(
	// 											'typeFixed.bonificate',
	// 											"6",
	// 											viabilityDataSubrogation?.fixedQuote.quote,
	// 											viabilityDataSubrogation?.fixedQuote.savings.total,
	// 											viabilityDataSubrogation?.fixedQuote.tae * 100,
	// 											viabilityDataSubrogation?.fixedQuote?.savings?.savingsByRest?.savingQuote,
	// 											viabilityDataSubrogation?.currentQuote,
	// 											viabilityDataSubrogation?.pendingTerm,
	// 											undefined,
	// 											'onboarding.fixedSpread',
	// 											viabilityDataSubrogation?.fixedQuote.savings.savingsByRest.section.tin * 100,
	// 											undefined,
	// 											undefined,
	// 											viabilityDataSubrogation?.fixedQuote.annualCostLinkages,
	// 											undefined,
	// 											undefined,
	// 											"fixed",
	// 											undefined
	// 										)}
	// 										{/* TIPO FIJO SIN BONIFICACION */}
	// 										{typeOfQuote(
	// 											'typeFixed.nobonificate',
	// 											"7",
	// 											viabilityDataSubrogation?.fixedQuoteWithoutBonifications.quote,
	// 											viabilityDataSubrogation?.fixedQuoteWithoutBonifications.savings.total,
	// 											viabilityDataSubrogation?.fixedQuoteWithoutBonifications.tae * 100,
	// 											viabilityDataSubrogation?.fixedQuoteWithoutBonifications?.savings?.savingsByRest?.savingQuote ?? 0,
	// 											viabilityDataSubrogation?.currentQuote,
	// 											viabilityDataSubrogation?.pendingTerm,
	// 											undefined,
	// 											'onboarding.fixedSpread',
	// 											viabilityDataSubrogation?.fixedQuoteWithoutBonifications.savings.savingsByRest.section.tin * 100,
	// 											undefined,
	// 											undefined,
	// 											viabilityDataSubrogation?.fixedQuoteWithoutBonifications.annualCostLinkages,
	// 											undefined,
	// 											undefined,
	// 											"fixed",
	// 											undefined
	// 										)}
	// 									</>
	// 								)}
	// 							</Row>
	// 							{viabilityDataSubrogation?.fixedQuote.savings.total > 0 && continueOperation}
	// 						</Tabs.TabPane>
	// 						<Tabs.TabPane tab={isMobileOnly ? t('mortgage.mixedtabmob').toUpperCase() : t('mortgage.mixedtab').toUpperCase()} key="2">
	// 							<Row gutter={24} style={{ margin: '-10px -8px 20px' }}>
	// 								{viabilityDataSubrogation?.mixedQuote.savings.total < 0 ? (
	// 									<>
	// 										<Col span={isMobileOnly ? 24 : 24} style={{ marginTop: 8 }}>
	// 											<div
	// 												className="card-subrogation-need-information"
	// 												style={{
	// 													columnGap: !isMobileOnly && 24,
	// 													flexDirection: isMobileOnly && 'column',
	// 													rowGap: isMobileOnly && 16
	// 												}}>
	// 												<img
	// 													src={isMobileOnly ? logoMortgageMobile : logoMortgage}
	// 													alt="logoMortgage"
	// 													height={'100%'}
	// 												/>
	// 												<div>
	// 													<div className="title-suborgation-information">
	// 														{t('onboarding.subrogationPayRed')}
	// 													</div>
	// 													<div
	// 														className="sub-title-suborgation-information"
	// 														dangerouslySetInnerHTML={{
	// 															__html: t('onboarding.subrogationPayRed2', {
	// 																rateType: t('mortgage.mixedtabmob').toLowerCase()
	// 															})
	// 														}}
	// 													/>
	// 												</div>
	// 											</div>
	// 										</Col>
	// 									</>
	// 								) : (
	// 									<>
	// 										{/* TIPO MIXTO BONIFICADO */}
	// 										{typeOfQuote(
	// 											'typeMixed.bonificate',
	// 											"2",
	// 											viabilityDataSubrogation?.mixedQuote.sections[0].monthlyPayment,
	// 											viabilityDataSubrogation?.mixedQuote.savings.total,
	// 											viabilityDataSubrogation?.mixedQuote.tae * 100,
	// 											viabilityDataSubrogation?.mixedQuote.savings.total,
	// 											viabilityDataSubrogation?.currentQuote,
	// 											viabilityDataSubrogation?.pendingTerm,
	// 											undefined,
	// 											'viability.mixedSpread',
	// 											viabilityDataSubrogation?.mixedQuote.sections[0].tin * 100,
	// 											viabilityDataSubrogation?.mixedQuote.sections[1].monthlyPayment,
	// 											viabilityDataSubrogation?.mixedQuote.sections[1].tin * 100,
	// 											viabilityDataSubrogation?.mixedQuote.annualCostLinkages,
	// 											dataOperation?.subrogation?.costOtherProducts,
	// 											dataOperation?.subrogation?.dateEndMortgage,
	// 											"mixed",
	// 											(viabilityDataSubrogation?.mixedQuote.sections[0].to + 1) / 12,
	// 										)}
	// 										{/* TIPO MIXTO SIN BONIFICAR */}
	// 										{typeOfQuote(
	// 											'typeMixed.nobonificate',
	// 											"3",
	// 											viabilityDataSubrogation?.mixedQuoteWithoutBonifications.sections[0].monthlyPayment,
	// 											viabilityDataSubrogation?.mixedQuoteWithoutBonifications.savings.total,
	// 											viabilityDataSubrogation?.mixedQuoteWithoutBonifications.tae * 100,
	// 											viabilityDataSubrogation?.mixedQuote.savings.total,
	// 											viabilityDataSubrogation?.currentQuote,
	// 											viabilityDataSubrogation?.pendingTerm,
	// 											undefined,
	// 											'viability.mixedSpread',
	// 											viabilityDataSubrogation?.mixedQuoteWithoutBonifications.sections[0].tin * 100,
	// 											viabilityDataSubrogation?.mixedQuoteWithoutBonifications.sections[1].monthlyPayment,
	// 											viabilityDataSubrogation?.mixedQuoteWithoutBonifications.sections[1].tin * 100,
	// 											viabilityDataSubrogation?.mixedQuoteWithoutBonifications.annualCostLinkages,
	// 											dataOperation?.subrogation?.costOtherProducts,
	// 											dataOperation?.subrogation?.dateEndMortgage,
	// 											"mixed",
	// 											(viabilityDataSubrogation?.mixedQuote.sections[0].to + 1) / 12,
	// 										)}
	// 									</>
	// 								)}
	// 							</Row>
	// 							{viabilityDataSubrogation?.mixedQuote.savings.total > 0 && continueOperation}
	// 						</Tabs.TabPane>
	// 						<Tabs.TabPane tab={isMobileOnly ? t('mortgage.varTabMob').toUpperCase() : t('mortgage.varTab').toUpperCase()} key="3">
	// 							<Row gutter={24} style={{ margin: '-10px -8px 20px' }}>
	// 								{viabilityDataSubrogation?.monthlyVariableSavings < 0 ? (
	// 									<>
	// 										<Col span={isMobileOnly ? 24 : 24} style={{ marginTop: 8 }}>
	// 											<div
	// 												className="card-subrogation-need-information"
	// 												style={{
	// 													columnGap: !isMobileOnly && 24,
	// 													flexDirection: isMobileOnly && 'column',
	// 													rowGap: isMobileOnly && 16
	// 												}}>
	// 												<img
	// 													src={isMobileOnly ? logoMortgageMobile : logoMortgage}
	// 													alt="logoMortgage"
	// 													height={'100%'}
	// 												/>
	// 												<div>
	// 													<div className="title-suborgation-information">
	// 														{t('onboarding.subrogationPayRed')}
	// 													</div>
	// 													<div
	// 														className="sub-title-suborgation-information"
	// 														dangerouslySetInnerHTML={{
	// 															__html: t('onboarding.subrogationPayRed2', {
	// 																rateType: t('form.variable')
	// 															})
	// 														}}
	// 													/>
	// 												</div>
	// 											</div>
	// 										</Col>
	// 									</>
	// 								) : (
	// 									<>
	// 										{/* TIPO VARIABLE BONIFICADO */}
	// 										{typeOfQuote(
	// 											'typeVar.bonificate',
	// 											"4",
	// 											viabilityDataSubrogation?.variableQuote.sections[0].monthlyPayment,
	// 											viabilityDataSubrogation?.variableQuote.savings.total,
	// 											viabilityDataSubrogation?.variableQuote.tae * 100,
	// 											viabilityDataSubrogation?.monthlyVariableSavings,
	// 											viabilityDataSubrogation?.currentQuote,
	// 											viabilityDataSubrogation?.pendingTerm,
	// 											undefined,
	// 											'viability.variableSpread',
	// 											viabilityDataSubrogation?.variableQuote.sections[0].tin * 100, //  fixedTin TIN PRIMER AÑO,
	// 											viabilityDataSubrogation?.variableQuote.sections[1].monthlyPayment, //  quote1 CUOTA RESTO DE AÑOS,
	// 											viabilityDataSubrogation?.variableQuote.sections[1].tin * 100, //  variable TIN RESTO AÑOS,
	// 											viabilityDataSubrogation?.variableQuote.annualCostLinkages,
	// 											dataOperation?.subrogation?.costOtherProducts,
	// 											dataOperation?.subrogation?.dateEndMortgage,
	// 											"variable",
	// 											undefined
	// 										)}
	// 										{/* TIPO VARIABLE SIN BONIFICAR */}
	// 										{typeOfQuote(
	// 											'typeVar.nobonificate',
	// 											"5",
	// 											viabilityDataSubrogation?.variableQuoteWithoutBonifications.sections[0].monthlyPayment,
	// 											viabilityDataSubrogation?.variableQuoteWithoutBonifications.savings.total,
	// 											viabilityDataSubrogation?.variableQuoteWithoutBonifications.tae * 100,
	// 											viabilityDataSubrogation?.monthlyVariableSavings,
	// 											viabilityDataSubrogation?.currentQuote,
	// 											viabilityDataSubrogation?.pendingTerm,
	// 											undefined,
	// 											'viability.variableSpread',
	// 											viabilityDataSubrogation?.variableQuoteWithoutBonifications.sections[0].tin * 100, //  fixedTin TIN PRIMER AÑO,
	// 											viabilityDataSubrogation?.variableQuoteWithoutBonifications.sections[1].monthlyPayment, //  quote1 CUOTA RESTO DE AÑOS,
	// 											viabilityDataSubrogation?.variableQuoteWithoutBonifications.sections[1].tin * 100, //  variable TIN RESTO AÑOS,
	// 											viabilityDataSubrogation?.variableQuoteWithoutBonifications.annualCostLinkages,
	// 											dataOperation?.subrogation?.costOtherProducts,
	// 											dataOperation?.subrogation?.dateEndMortgage,
	// 											"variable",
	// 											undefined
	// 										)}
	// 									</>
	// 								)}
	// 							</Row>
	// 							{viabilityDataSubrogation?.variableQuote.savings.total > 0 && continueOperation}
	// 						</Tabs.TabPane>
	// 					</Tabs>
	// 					<Card
	// 						className="card-button-style-onboading"
	// 						style={{
	// 							left: 0,
	// 							marginBottom: -2,
	// 							backgroundColor: '#FAFEFE'
	// 						}}>
	// 						{viabilityDataSubrogation &&
	// 							<Button
	// 								id="gb-mortgage-buy-situation-mobile"
	// 								className="button-primary-gibobs-inmo"
	// 								type="primary"
	// 								style={{
	// 									fontSize: '14px',
	// 									width: isMobileOnly ? '100%' : 248,
	// 									height: 48,
	// 									fontWeight: 600,
	// 									zIndex: 1200
	// 								}}
	// 								onClick={() => changesStage('process', 'basicCompleted', true)}
	// 								htmlType="submit"
	// 								disabled={
	// 									renderDisabled(dataOperation, viabilityDataSubrogation)
	// 								}>
	// 								{t('viability.continue')}
	// 							</Button>
	// 						}
	// 					</Card>

	// 					<div className="description-viability">
	// 						<CondictionsLegal></CondictionsLegal>
	// 					</div>
	// 					{/* MODALES */}
	// 					<DifferenceInQuota
	// 						key={'visibleModalCalculationAmount'}
	// 						visible={visibleModalCalculationAmount}
	// 						onCreate={() => setVisibleModalCalculationAmount(false)}
	// 						onCancel={() => setVisibleModalCalculationAmount(false)}
	// 						width={800}
	// 						dataOperation={dataOperation && dataOperation.subrogation}
	// 					/>
	// 					<TotalDifference
	// 						key={'visibleModalSavings'}
	// 						visible={visibleModalSavings}
	// 						onCreate={() => setVisibleModalSavings(false)}
	// 						onCancel={() => setVisibleModalSavings(false)}
	// 						width={800}
	// 						dataOperation={dataOperation && dataOperation.subrogation}
	// 					/>
	// 				</div>
	// 			) : (
	// 				<Spin indicator={antIcon} className="spin" />
	// 			))}
	// 	</>
	// );
};

export default ResultSubrogation;
